<template>
  <div>
    <Table border ref="selection" :columns="columns" :data="data" width="500" v-show="false">
      <template slot-scope="{ row, index }" slot="action">
        <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editBtn(row, index)"></Icon>
      </template>
    </Table>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="6" hide-arrow style="margin: 20px 0;border:0">
        <FormTitle titleText="基本信息"/>
        <Form :label-width="150" label-position="left" slot="content" style="margin: 30px 30px 0 30px">
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工工号">
                <Input v-model="userinfoItem.empCode" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工姓名">
                <Input v-model="userinfoItem.userName" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工职位">
                <Input v-model="userinfoItem.positionName" disabled />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="月份">
                <Input v-model="userinfoItem.month" disabled />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel v-show="showKPI" name="1" hide-arrow style="margin: 20px 0;border:0">
        <FormTitle titleText="KPI"/>
        <div v-show="showKPI" slot="content">
          <Table border :columns="columns1" :data="data1" style="margin: 30px 20px">
          </Table>
          <Table border :columns="columns2" :data="data2" style="margin: 0 20px" v-show="showKPIDetail">
          </Table>
        </div>
      </Panel>
      <Panel v-show="showBSC" name="2" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle titleText="BSC"/>
        <div v-show="showBSC" slot="content">  
          <Table border :columns="columns3" :data="data3"  width="400" style="margin: 30px 20px">
          </Table>
          <Table border :columns="columns4" :data="data4" style="margin: 0 20px" v-show="showBSCDetail">
          </Table>
        </div>
      </Panel>
      <Panel v-show="showPlan" name="3" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle titleText="个人发展计划"/>
        <div v-show="showPlan" slot="content">
          <Table border :columns="columns5" :data="data5" style="margin: 30px 20px 0 20px">
          </Table>
        </div>
      </Panel>
      <Panel v-show="showWork" name="4" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle titleText="重点工作"/>
        <div v-show="showWork" slot="content">
          <Table border :columns="columns6" :data="data6" style="margin: 30px 20px 0 20px">
          </Table>
        </div>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle titleText="审批历史" style="margin-top:20px"/>
        <Table border :columns="columns9" :data="data9" slot="content" style="margin:20px">
        </Table>
      </Panel>
    </Collapse>
    <div class="btnRight">
      <Button type="primary" class="applyBtnRight" @click="returnPage">返回</Button>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value:[1, 2, 3, 4, 5, 6],
      formItem1:{},
      formItem2:{},
      formItem3:{},
      formItem4:{},
      formItem5:{},
      formItem6:{},
      columns: [
        {
          title: "模板类型",
          key: "achTypeName",
          align: "center",
        },
        {
          title: "查看",
          slot:"action",
          align: "center",
          width: "200",
        },
      ],
      data: [],
      // KPI 指标
      columns1: [
        {
          title: "指标项",
          key: "targetItem",
          align: "center",
        },
        {
          title: "内容概述",
          key: "content",
          align: "center",
          width:'330',
        },
        {
          title: "权重（%）",
          key: "weight",
          align: "center",
        },
        {
          title: "评分方法",
          key: "method",
          align: "center",
        },
        {
          title: "数据来源",
          key: "dataFrom",
          align: "center",
        },
      ],
      data1: [],
      // 指标->子表格
      columns2: [
        {
          title: "指标项",
          key: "targetItemRepeat",
          align: "center",
        },
        {
          title: "内容概述",
          key: "contentRepeat",
          align: "center",
        },
        {
          title: "目标分解",
          key: "targetDisintegrate",
          align: "center",
        },
        {
          title: "达成效果",
          key: "reachEffect",
          align: "center",
        },
      ],
      data2: [],
      // bsc
      columns3: [
        {
          title: "指标维度",
          key: "targetDimension",
          align: "center",
        },
      ],
      data3: [],
      // bsc->子页面
      columns4: [
        {
          title: "指标维度",
          key: "targetDemensionRepeat",
          align: "center",
          width: '200',
        },
        {
          title: "衡量要素",
          key: "measure",
          align: "center",
          width: '200',
        },
        {
          title: "指标名称",
          key: "targetName",
          align: "center",
          width: '200',
        },
        {
          title: "指标定义",
          key: "targetDefine",
          align: "center",
          width: '265',
        },
        {
          title: "设立目的",
          key: "aimFound",
          align: "center",
          width: '260',
        },
        {
          title: "数据收集",
          key:"dataCollect",
          align: "center",
          width: '210',
        },
        {
          title: "备注",
          key:"remark",
          align: "center",
          width: '210',
        },
      ],
      data4: [],
      // 个人发展计划
      columns5: [
        {
          title: "待提高或发展的能力/经验",
          key: "heighten",
          align: "center",
        },
        {
          title: "实施活动及衡量标准（活动要具体、个性化、可衡量）",
          key: "activesPerformed",
          align: "center",
        },
        {
          title: "计划完成时间（计划要可执行）",
          key: "completeDate",
          align: "center",
          render: (h, params) => {
              return h(
                "span",
                this.date.dateVal(params.row.completeDate, "YYYY-MM-DD")
              );
          },
        },
      ],
      data5: [],
      // 重点工作
      columns6: [
        {
          title: "解决的挑战及目标描述",
          key: "describe",
          align: "center",
        },
        {
          title: "完成的标准及交附件",
          key: "standard",
          align: "center",
        },
        {
          title: "权重（%）",
          key: "weight",
          align: "center",
        },
        {
          title: "关键举措",
          key: "initiatives",
          align: "center",
        },
      ],
      data6: [],
      loading: false,
      showKPI: false,
      showBSC: false,
      showKPIDetail: false,
      showBSCDetail: false,
      showPlan: false,
      showWork: false,
      isHistory: false,
      ach_info_id: '',
      ruleValidate: {
        message: [{ required: true,message: this.$t('请填写驳回意见') + '！'}]
      },
      showdataAgree:false,    //审批意见
      showdataRejected:false,  //驳回意见
      rejectMessage:{},                   
      columns9: [
        {
          title: this.$t('审批流名称'),
          key: "stepName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('实际审批者'),
          key: "userName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('审批时间'),
          key: "time",
          align: "center",
          width:"280",
          render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
                    );
                },
        },
        {
          title: this.$t('审批状态'),
          key: "status",
          align: "center",
          width:"270",
          render: (h, params) => {
                    return h(
                    "span",
                    params.row.status == "0" ? "通过" : params.row.status == "1" ? "驳回" : ""
                    );
                },
        },
        {
          title: this.$t('审批意见'),
          key: "message",
          align: "center",
          width:"435",
        },
      ],
      data9:[],
      userinfoItem:{}
    };
  },
  mounted(){
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
    this.getData()
  },
  methods: {
    getData(){
      let obj1 = {
        instanceId : this.getQueryVariable("instanceId")
      }
      this.loading = true
      axios.post('/ApplyAchStartYear/selectAchStartYearDetails',obj1).then(res1=>{
        this.loading = false
        this.data = res1.typeList
        this.data1 = res1.kpi
        this.data3 = res1.bsc
        this.data5 = res1.plan
        this.data6 = res1.work
        this.data9 = res1.logMap
        this.userinfoItem = res1.basicInfo
        this.data.forEach(item=>{
          if(item.achTypeCode == 'work'){
            this.showWork = true
          }else if(item.achTypeCode == 'kpi'){
            this.showKPI = true
            if(res1.kpidecomposeList.length>0){
              this.data2 = res1.kpidecomposeList
              this.showKPIDetail = true
            }
          }else if(item.achTypeCode == 'bsc'){
            this.showBSC = true
            if(res1.bscdecomposeList.length>0){
              this.data4 = res1.bscdecomposeList
              this.showBSCDetail = true
            }
          }else if(item.achTypeCode == 'plan'){
            this.showPlan = true
          }
        })
      })
    },
    returnPage() {
      if(this.isHistory){
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/process/Apply/ApplyHistoryAchStartYear.vue